<template>
  <div class="viewCodeDialog">
    <div style="text-align:center">微信扫一扫：报名</div>
    <vue-qr
      :text="qrOptions.url"
      :size="qrOptions.size"
      :margin="qrOptions.margin"
      :backgroundColor="qrOptions.backgroundColor"
      :colorDark="qrOptions.colorDark"
      :logoSrc="qrOptions.logoSrc"
      :colorLight="qrOptions.colorLight"
      :logoScale="qrOptions.logoScale"
      :logoMargin="qrOptions.logoMargin"
      :logoCornerRadius="qrOptions.logoCornerRadius"
      :bgSrc="qrOptions.bgSrc"
      :correctLevel="qrOptions.correctLevel"
    >
    </vue-qr>
  </div>
</template>

<script>
import VueQr from "../../utils/vue-qr/vue-qr.js"
export default {
  components: {
    VueQr,
  },
  data() {
    return {
      title: "",
      qrOptions: {
        url: "",
        colorLight: "#fff",
        colorDark: "#000000",
        backgroundColor: "#fff",
        logoSrc: "",
        logoScale: 0.2, //超过0.2基本上无法识别
        logoMargin: 2,
        logoCornerRadius: 0,
        bgSrc: "",
        size: 200,
        margin: 20,
        correctLevel: 3,
      },

      imgUrl: "",
      logoSrc: "",
    }
  },
  methods: {
    initData(courseCode, logoUrl) {
      this.qrOptions.url =
        "https://edu.zhuzaocloud.com/mobile/cecoursePackage/info/" +
        courseCode +
        "?flag=" +
        courseCode
    },
  },
}
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  /* padding: 20px; */
  padding-top: 0;
  padding-bottom: 10px;
}
/deep/ .el-dialog__body {
  padding: 11px 22px 5px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.create-lr-box {
  width: calc(50% - 8px);
  background-color: #f9f9f9;
  box-shadow: rgba(60, 64, 67, 0.3) 0 1px 2px 0,
    rgba(60, 64, 67, 0.15) 0 1px 3px 1px;
  color: #6c6a6f;

  .code-qr-box {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #6c6c6c;
    padding: 10px;
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/talentServices/wechartQrCode.vue